import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * HubSpot Log Call Activity v1 Configuration Validator
 * Validates HubSpot call activity logging with contact validation
 */
export const Hubspot_Log_Call_Activity_1_ConfigValidator = z
    .object({
    hubspotConnection: requiredString('HubSpot Connection is required'),
    customProperties: z.record(z.string(), z.any()).optional(),
    createContactIfNotFound: z.boolean().optional(),
    contactProperties: z.record(z.string(), z.any()).optional(),
    associatedContactId: z.string().optional(),
    associatedContactPhoneNumber: z.string().optional(),
    callDispositionMappingOutbound: z.record(z.string(), z.any()).optional(),
    callDispositionMappingInbound: z.record(z.string(), z.any()).optional()
})
    .refine((data) => {
    const hasContactId = data.associatedContactId && data.associatedContactId.trim() !== '';
    const hasContactPhone = data.associatedContactPhoneNumber && data.associatedContactPhoneNumber.trim() !== '';
    return (hasContactId || hasContactPhone) && !(hasContactId && hasContactPhone);
}, {
    path: ['contact'],
    error: 'Please fill in either Contact ID or Contact Phone Number'
});
//# sourceMappingURL=hubspot-log-call-activity-1.js.map